import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../../Services/crud.service";
import { LogedInUserService } from "../../../Services/loged-in-user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { NgbAccordionConfig } from "@ng-bootstrap/ng-bootstrap";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { ThemeOptions } from "../../../theme-options";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormStateService } from "src/app/Services/form.service";
import { GenerateAiContentComponent } from "src/app/Modals/generate-ai-content/generate-ai-content.component";
import { v4 as uuidv4 } from "uuid";

@Component({
  selector: "app-dynamic-tooltip-form",
  templateUrl: "./dynamic-tooltip-form.component.html",
  styles: [
    `
      ::ng-deep
        .ng-select
        .ng-select-container
        .ng-value-container
        .ng-input
        > input {
        padding-top: 0px !important;
      }
      ::ng-deep .ng-select .ng-select-container .ng-placeholder {
        padding-top: 5px !important;
      }
      ::ng-deep .ng-select .ng-select-container .ng-value {
        margin-left: 5px;
      }
      ::ng-deep .ng-select .ng-select-container {
        background-color: #fff;
        border: 1px solid #ced4da !important;
        border-radius: 0.25rem !important;
      }
    `,
  ],
  standalone: false,
})
export class DynamicTooltipFormComponent implements OnInit, OnChanges {
  @Input() tooltip;
  @Input() project;
  @Input() roles;
  @Input() screen;
  @Input() selectedVersion;
  @Input() addTooltip;
  @Input() languageChange: any = "";
  @Output() onLanguageChange = new EventEmitter<any>();
  @Output() formSubmitted: EventEmitter<void> = new EventEmitter<void>();
  closeResult;
  form: UntypedFormGroup;
  currentTooltip;
  languageList = [];
  disableSave = false;
  publishToProd = false;
  publishToQA = false;
  versionList = [];
  submitted = false;
  primaryLanguage = "";

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "yes",
    toolbarHiddenButtons: [["insertImage", "insertVideo"]],
  };

  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    public globals: ThemeOptions,
    private modalService: NgbModal,
    private formStateService: FormStateService
  ) {
    this.getLanguages();
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["languageChange"]) {
      this.form.patchValue({
        hint: this.languageChange["hint"],
        laguageId: this.languageChange["languageId"],
        id: this.languageChange["id"],
      });
      // console.log("received language change", this.languageChange);
    }
  }

  ngOnInit() {
    // console.log("Roles", this.roles, "Tooltip Here", this.tooltip);
    this.showSelectedLangaugeTooltip.bind(this);
    this.form = this.formBuilder.group({
      name: ["", Validators.required, ""],
      hint: ["", Validators.required, ""],
      projectVersion: ["", ""],
      element: ["", Validators.required, ""],
      elementSelector: ["", Validators.required, ""],
      hintPosition: ["", Validators.required, ""],
      tooltipCSS: ["", ""],
      position: ["", ""],
      status: ["", ""],
      languageId: [],
      screenManagementId: [],
      projectManagementId: [],
      roles: [],
      id: ["", Validators.required, ""],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        // console.log("form is dirty");
        this.formStateService.setFormDirty();
      }
    });

    if (this.project != undefined) {
      this.primaryLanguage = this.project.primaryLanguage;
    }
    this.currentTooltip = Object.assign({}, this.tooltip);
    this.form.patchValue(this.currentTooltip);
    if (this.currentTooltip && this.currentTooltip.tooltipId != undefined) {
      this.getlastPublishStage(this.currentTooltip.tooltipId);
    }
  }

  get f() {
    return this.form.controls;
  }

  getlastPublishStage(tooltipId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (response.publishStage == "dev") {
          self.publishToQA = true;
          self.publishToProd = false;
        } else if (response.publishStage == "qa") {
          self.publishToQA = false;
          self.publishToProd = true;
        } else if (response.publishStage == "prod") {
          self.publishToProd = false;
        }
      },
      `currentTooltipDetails/findOne?filter[order]=updatedAt DESC&filter[where][tooltipId]=${tooltipId}`
    );
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  onSubmit() {
    this.submitted = true;
    var self = this;

    Object.keys(this.form.controls).forEach((key) => {
      const control = this.form.get(key);
      if (control?.errors?.["required"]) {
        console.log(`Control '${key}' is missing a required value.`);
      }
    });

    var { id } = this.form.value;
    var payload = {
      ...this.form.value,
      id: undefined,
      publishStage: "dev",
      tooltipId: this.currentTooltip.tooltipId,
      elementData: this.currentTooltip.elementData,
      nodeIds: this.currentTooltip.nodeIds,
      marginTop: this.currentTooltip.marginTop,
      marginRight: this.currentTooltip.marginRight,
      marginBottom: this.currentTooltip.marginBottom,
      marginLeft: this.currentTooltip.marginLeft,
      projectManagementId: this.project.id,
      screenManagementId: this.screen.id,
      roles: this.currentTooltip.roles,
    };
    if (this.addTooltip == true) {
      var tooltipsPayload = {
        projectManagementId: this.project.id,
        screenManagementId: this.screen.id,
        languageId: this.primaryLanguage,
      };
      this.crudService.post(
        tooltipsPayload,
        (response) => {
          payload["languageId"] = this.primaryLanguage;
          payload["projectVersion"] = this.selectedVersion;
          payload["elementSelector"] = this.form.value["elementSelector"];
          payload["element"] = this.form.value["element"];
          payload["elementData"] = {
            elementId:
              this.form.value["elementSelector"] == "Id" &&
              this.form.value["element"] != ""
                ? this.form.value["element"]
                : "",
            elementClass:
              this.form.value["elementSelector"] == "Class" &&
              this.form.value["element"] != ""
                ? this.form.value["element"]
                : "",
            elementPath:
              this.form.value["elementSelector"] == "Path" &&
              this.form.value["element"] != ""
                ? this.form.value["element"]
                : "",
            elementTagName:
              this.form.value["elementSelector"] == "Name" &&
              this.form.value["element"] != ""
                ? this.form.value["element"]
                : "",
            elementXPath:
              this.form.value["elementSelector"] == "XPath" &&
              this.form.value["element"] != ""
                ? this.form.value["element"]
                : "",
          };
          payload["tooltipId"] = response["id"];
          this.crudService.post(
            payload,
            function (response) {
              if (
                response.error &&
                response.error.error &&
                response.error.error.message
              ) {
                self.toastr.error(
                  response.error.error.message,
                  "Invalid Operation"
                );
                self.form.markAsPristine();
                self.formStateService.clearFormDirty();
              } else {
                self.toastr.success(
                  "Tooltip has been created successfully.",
                  "Success"
                );
                self.formSubmitted.emit();
                self.form.markAsPristine();
                self.formStateService.clearFormDirty();
                self.ngOnInit();
              }
            },
            "currentTooltipDetails"
          );
        },
        "tooltips"
      );
      // stop here if form is invalid
    } else {
      // stop here if form is invalid
      if (this.form.invalid) return;
      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
          } else {
            self.toastr.success(
              "Tooltip has been created successfully.",
              "Success"
            );
            self.formSubmitted.emit();
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
          }
        },
        "currentTooltipDetails/" + this.tooltip.id
      );
      self.getlastPublishStage(this.currentTooltip.tooltipId);
    }

    this.submitted = false;
  }

  onReset() {
    this.submitted = false;
    this.form.patchValue(this.currentTooltip);
    this.form.markAsPristine();
    this.formStateService.clearFormDirty();
  }

  onClickOfPublish(publishStage: string) {
    var self = this;
    if (this.form.invalid) return;
    var payload = {
      ...this.form.value,
      id: undefined,
      publishStage: publishStage,
      tooltipId: this.currentTooltip.tooltipId,
      elementData: this.currentTooltip.elementData,
      nodeIds: this.currentTooltip.nodeIds,
      marginTop: this.currentTooltip.marginTop,
      marginRight: this.currentTooltip.marginRight,
      marginBottom: this.currentTooltip.marginBottom,
      marginLeft: this.currentTooltip.marginLeft,
      projectManagementId: this.project.id,
      roles: this.currentTooltip.roles,
    };
    this.crudService.post(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        } else {
          self.toastr.success(
            "Tooltip has been published successfully.",
            "Success"
          );
          self.formSubmitted.emit();
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        }
      },
      "currentTooltipDetails"
    );
    self.getlastPublishStage(this.currentTooltip.tooltipId);
  }

  showSelectedLangaugeTooltip(languageId) {
    let self = this;

    if (languageId === self.project.primaryLanguage) {
      // Default primary language case
      this.currentTooltip = Object.assign({}, this.tooltip);
      this.form.patchValue(this.currentTooltip);
      self.onLanguageChange.emit({
        id: self.currentTooltip.id,
        name: self.getLanguageName(languageId),
      });
    } else if (languageId !== self.project.primaryLanguage) {
      // other then primary langauge case
      // fetch tooltip with parentid of existing one and see do we have nay tooltips already exist with this.
      self.crudService.get(
        null,
        function (response) {
          var isTooltipExistForSelectedLangauge =
            response &&
            response.length &&
            response.find(function (val) {
              return val.languageId === languageId;
            });
          if (isTooltipExistForSelectedLangauge) {
            self.currentTooltip = isTooltipExistForSelectedLangauge;
            self.form.patchValue(isTooltipExistForSelectedLangauge);
            self.onLanguageChange.emit({
              id: self.currentTooltip.parentId,
              name: self.getLanguageName(languageId),
            });
          } else {
            // Copy primary language tooltip with newly/selected language and keep parent id as primary language tooltip
            let newobj = { ...self.tooltip, parentId: self.tooltip.id };
            newobj.languageId = languageId;
            delete newobj.id;
            self.crudService.post(
              newobj,
              function (response) {
                if (
                  response.error &&
                  response.error.error &&
                  response.error.error.message
                ) {
                  self.toastr.error(
                    response.error.error.message,
                    "Invalid Operation"
                  );
                } else {
                  self.toastr.success(
                    "Tooltip has been created for new language successfully.",
                    "Success"
                  );
                  self.formSubmitted.emit();
                  self.currentTooltip = response;
                  self.form.patchValue(response);
                  self.onLanguageChange.emit({
                    id: self.currentTooltip.parentId,
                    name: self.getLanguageName(languageId),
                  });
                }
              },
              "tooltipDetails"
            );
          }
        },
        'tooltipDetails?filter={"where":{"parentId":"' + self.tooltip.id + '"}}'
      );
    }
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  navigateProjectScreen() {
    this.router.navigate(["/page/project-management", this.project.id]);
  }

  open(content) {
    this.modalService.open(content);
  }

  getNewLanguage() {
    var self = this;
    var newlan = [];
    self.languageList.forEach(function (lan) {
      var isExist = self.project.supportedLanguage.find(function (sl) {
        return sl.id === lan.id;
      });
      if (!isExist && lan.id != self.project.primaryLanguage) {
        newlan.push(lan);
      }
    });
    return newlan;
  }

  saveNewSelectedLanguage(newLanguageList) {
    var self = this;
    if (newLanguageList.selectedOptions.selected.length) {
      newLanguageList.selectedOptions.selected.forEach((selectedNewLan) => {
        var isExist = self.languageList.find(function (sl) {
          return sl.name == selectedNewLan.getLabel().trim();
        });
        if (isExist) {
          self.project.supportedLanguage.push(isExist);
        }
      });

      self.crudService.update(
        self.project,
        function (response) {
          if (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.project = response;
              self.toastr.success(
                "New language added successfully to the project.",
                "Success"
              );
            }
          }
        },
        "projectManagements"
      );
    }
    self.modalService.dismissAll();
  }
  onSelectionChange(event) {}
  generateContentForTooltip() {
    const modalref = this.modalService.open(GenerateAiContentComponent, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      keyboard: false,
      windowClass: "top-modal custom-width-modal",
    });
    modalref.componentInstance.title = "Tooltip";
    modalref.componentInstance.prompt = `You are writing a user-facing tooltip description for a UI element within a project.
          Context:
          - Tooltip Name: ${
            this.form.value["name"].trim() != ""
              ? this.form.value["name"]
              : "(No tooltip name provided)"
          }
          - Project Name: ${this.project.name}
          - Project Description: ${
            this.project.description && this.project.description.trim() !== ""
              ? this.project.description
              : "(No description provided)"
          }
          - Screen/Module Name: ${this.screen.name}
          - Screen Description: ${
            this.screen.description && this.screen.description.trim() !== ""
              ? this.screen.description
              : "(No description provided)"
          }
        
          Instruction:
          Write a clear, concise, and helpful tooltip description that aligns with the context. It should assist end users in understanding the feature, field, or element it is attached to. Avoid technical jargon unless necessary, and focus on usability and clarity.
       `;
    modalref.componentInstance.projectId = this.project.id;
    modalref.componentInstance.screenId = this.screen.id;
    modalref.componentInstance.currentScreen = this.screen;
    modalref.componentInstance.selectedVersion = this.selectedVersion;
    modalref.componentInstance.contentResponseforTooltip.subscribe(
      (response) => {
        if (
          response !== undefined &&
          response !== null &&
          typeof response === "string" &&
          response.trim() !== ""
        ) {
          this.form.patchValue({
            hint: response,
          });
          this.form.get("hint")?.markAsDirty();
        }
      }
    );
    modalref.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }
}
